import paypalTokensTemplate from './paypalTokens.html';

/*******************************************************************************
 * @ngdoc    component
 * @name     csm.books.OurOrg.component:paypalTokens
 * @constructor
 * @param {object=} apiTokens    PayPal processor tokens.
 * @param {string}  defaultName  Default account name = username.
 * @description
 * Takes input of PayPal processor tokens.
 *******************************************************************************/
export const paypalTokensComponent = {
  template: paypalTokensTemplate,
  bindings: { apiTokens: '<', defaultName: '=' },
  controller: paypalTokensController
}

/* @ngInject */ function paypalTokensController($scope) {
  const $ctrl = this;
  const setName = (nv) => ($ctrl.defaultName = nv);
  $scope.$on('destroy', $scope.$watch('$ctrl.apiTokens.USER', setName));
}